import { gtmEvent, filterUndefinedAndEmptyValues } from '../../../utils/gtmEvents';
import { removeAllTagsFromMarkdown } from '../../../utils/markdown';
const gtmPushHandler = ({ dealerName, modelName, bodyStyle, trimName, modelYear, event = 'select_trim', }) => {
    gtmEvent(filterUndefinedAndEmptyValues({
        event,
        dealer_name: dealerName,
        model: modelName,
        body_style: bodyStyle,
        trim: removeAllTagsFromMarkdown(trimName),
        model_year: modelYear,
    }));
};
export default gtmPushHandler;
